import { FC } from 'react';
import Image from 'next/image';

export const Logo: FC = () => {
  return <Image src='/images/logo.svg' width={119} height={38.68} alt='Joyline' />;
};
